/**
 * @deprecated: 待修改为新版本restService
 */
import { appConfig } from "@env/app-config";
export class PartnerRestService {

    public static readonly $inject: string[] = ["$rest"];

    constructor(private $rest: qpmn.common.rest.IRestService) { }
    /**
     * @description: 重新发送partner验证邮件
     * @deprecated
     * @return {*}
     */
    public sendmail(): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.user.model.dto.partner.PartnerVerificationDto>> {
        return this.$rest.http<qpmn.user.model.dto.partner.PartnerVerificationDto>("partnerRestService", "sendmail", {
            platform: appConfig.websiteCode
        });
    }

    /**
     * @description: 获取注册邮箱验证结果
     * @deprecated
     * @param {qpmn} token
     * @return {*}
     */
    public verify(token: string | null): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.user.model.dto.partner.PartnerVerificationDto>> {
        let paramDefaults = {
            token: token
        };

        return this.$rest.http<qpmn.user.model.dto.partner.PartnerVerificationDto>("partnerRestService", "verify", paramDefaults);
    }

    /**
     * @description: 获取partner验证结果
     * @deprecated
     * @return {*}
     */
    public partnerInfo(): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.user.model.dto.partner.IPartnerInfo>> {
        return this.$rest.http<qpmn.user.model.dto.partner.IPartnerInfo>("partnerRestService", "partnerInfo");
    }

    /**
     * @deprecated
     * @description: 
     */
    public eshopperInfo(): angular.IPromise<qpmn.common.rest.IRestResponse<qpmn.user.model.dto.partner.IEShopperInfo>> {
        return this.$rest.http<qpmn.user.model.dto.partner.IEShopperInfo>("partnerRestService", "eshopperInfo");
    }

    public updateEShopperInfo(eshopper: qpmn.user.model.dto.partner.IEShopperInfo) {
        return this.$rest.http<qpmn.user.model.dto.partner.IEShopperInfo>("partnerRestService", "updateEShopperInfo", eshopper);
    }
}